import { render, staticRenderFns } from "./vanOffline.vue?vue&type=template&id=51956500&scoped=true&"
import script from "./vanOffline.vue?vue&type=script&lang=js&"
export * from "./vanOffline.vue?vue&type=script&lang=js&"
import style0 from "./vanOffline.vue?vue&type=style&index=0&id=51956500&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51956500",
  null
  
)

export default component.exports